// Combination. What is left when no single device explains the line but it
// still wins something: the first move gives material up to get more
// (`sacrifice`: the piece lands where it can be taken for less than it is
// worth, or takes less than it gives), or the line wins material (the
// fact's `lost` or `missed`) by a device this pass does not name
// (deflection, attraction, interference, clearance, intermezzo, x-ray,
// zugzwang: the family alone, no variation). A line that wins nothing is
// no combination: `positional`, the classifier's last word.
import type { Motif } from '@chess/api-mistakes';
import type { TacticLine } from './line.ts';
import { moved, safe, VALUE } from './rays.ts';

export function combination(line: TacticLine): Motif | undefined {
  const first = line.pv[0];
  const m = first ? moved(line.board, first) : undefined;
  if (!m) return undefined;
  const gives = m.piece.kind !== 'king' && !safe(m.after, m.to) && (!m.captured || VALUE[m.captured.kind] < VALUE[m.piece.kind]);
  if (gives) return { family: 'combination', variation: 'sacrifice' };
  return line.material ? { family: 'combination' } : undefined;
}
